import React from "react";
import { FaClock, FaSignInAlt, FaSignOutAlt, FaBuilding } from "react-icons/fa";

const ClockRecordCard = ({ record, formatDate, calculateDuration }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden transition-all hover:shadow-md hover:translate-y-[-2px]">
      <div className="p-4">
        <div className="flex justify-between items-start mb-2">
          <div className="text-sm font-medium text-[#363062]">
            {formatDate(record.date)}
          </div>
          <div
            className={`flex items-center px-2 py-1 rounded-full text-xs font-medium ${
              record.clockOutTime
                ? "bg-gray-200 text-gray-700"
                : "bg-[#8FCD00]/15 text-[#8FCD00]"
            }`}
          >
            {record.clockOutTime ? "Completed" : "Active"}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 text-xs text-gray-600 mb-3">
          <div className="flex items-center gap-1.5">
            <FaSignInAlt className="text-green-500 flex-shrink-0" />
            <span>In: {record.clockInTime || "N/A"}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <FaSignOutAlt className="text-red-500 flex-shrink-0" />
            <span>Out: {record.clockOutTime || "Pending"}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <FaBuilding className="text-gray-400 flex-shrink-0" />
            <span>{record.location || "Main Office"}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <FaClock className="text-gray-400 flex-shrink-0" />
            <span>
              Duration:{" "}
              {calculateDuration(record.clockInTime, record.clockOutTime)}
            </span>
          </div>
        </div>

        {/* Notes Section */}
        {record.notes && (
          <div className="mt-2 pt-2 border-t border-gray-100">
            <div className="text-xs text-gray-500 mb-1">Notes:</div>
            <div className="text-xs text-gray-700">{record.notes}</div>
          </div>
        )}
      </div>
      {/* Footer */}
      <div className="flex justify-end items-center py-2 px-4 bg-gray-50 border-t border-gray-100">
        <div className="flex items-center text-xs font-medium text-[#363062]">
          {record.status === "active" ? "In Progress" : "Completed"}
        </div>
      </div>
    </div>
  );
};

export default ClockRecordCard;
